import { render } from "./displayScreen.vue?vue&type=template&id=1ecbf418&scoped=true"
import script from "./displayScreen.vue?vue&type=script&lang=js"
export * from "./displayScreen.vue?vue&type=script&lang=js"

import "./displayScreen.vue?vue&type=style&index=0&id=1ecbf418&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecbf418"]])

export default __exports__